import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { Button } from '@uhg-abyss/web/ui/Button';
import { IconMaterial } from '@uhg-abyss/web/ui/IconMaterial';

const FlexStyle = styled(Flex, {
  padding: '10px 10px 40px 10px',
});
const MessageStyle = styled(Flex.Content, {
  paddingLeft: 8,
});
const StyledModal = styled(Modal, {
  '& > div > button': {
    top: '42px',
    right: '58px',
  },
});
const ModalTitle = styled('h2', {
  color: '$primary1',
  borderBottom: '1px solid $gray4 !important',
  padding: '40px 40px 20px 40px !important',
});

export const ProviderConfirmationModal = ({ isOpen, onCancel, onContinue }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleOnContinue = (e) => {
    setIsLoading(true);
    onContinue();
  };

  useEffect(() => {
    if (isLoading) {
      setIsLoading(false);
    }
  }, [isOpen]);

  return (
    <StyledModal isOpen={isOpen} onClose={onCancel} size="42%" title="">
      <ModalTitle>Are You Sure ?</ModalTitle>
      <Modal.Section>
        <FlexStyle>
          <Flex.Content space-5>
            <IconMaterial icon="warning" color="$warning1" />
          </Flex.Content>
          <MessageStyle space-95>
            The information displayed on the page will refresh based on a new
            <br /> selection. Are you sure you'd like to proceed?
          </MessageStyle>
        </FlexStyle>
      </Modal.Section>
      <Flex align="center" justify="flex-end">
        <Button
          id="cancel-button"
          role="button"
          variant="outline"
          aria-label="Cancel Saving Provider Selection"
          aria-labelledby="cancel-save-provider-selection"
          onClick={onCancel}
          styles={{
            button: (base) => ({
              ...base,
              margin: '10px 0px 25px 0px',
              paddingLeft: '20px',
              paddingRight: '20px',
            }),
          }}
        >
          Cancel
        </Button>
        <Button
          id="continue-button"
          role="button"
          theme="primary"
          aria-label="Continue Saving Provider Selection"
          aria-labelledby="continue-save-provider-selection"
          onClick={handleOnContinue}
          isLoading={isLoading}
          styles={{
            button: (base) => ({
              ...base,
              margin: '10px 58px 25px 15px',
              paddingLeft: '20px',
              paddingRight: '20px',
            }),
          }}
        >
          Continue
        </Button>
      </Flex>
    </StyledModal>
  );
};

ProviderConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
};
